import { render, staticRenderFns } from "./OperaDataPermissionWindow.vue?vue&type=template&id=efdc5fe6&"
import script from "./OperaDataPermissionWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDataPermissionWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports